module.exports = __webpack_public_path__ + "static/media/03.99e1eacc.jpg";